import classNames from "classnames";
import { BrandMenu } from "./BrandMenu";
import { LocationMenu } from "./LocationMenu";
import { UserPopover } from "./UserPopover";
import { ModulePopover } from "./ModulePopover";
import { useAdminSelector } from "../../../stores/AdminStore";

interface NavBarProps {
  isDisabled: boolean;
}

const NavBar = ({ isDisabled }: NavBarProps) => {
  const open = useAdminSelector((s) => s.menu.open);

  return (
    <div
      className={classNames(
        "h-16 md:h-14 bg-black text-white fixed top-0 right-0 z-40",
        open ? "hidden md:flex left-80" : "left-8 md:left-14 flex"
      )}
    >
      <div className="flex-grow flex flex-col md:flex-row md:text-xl h-full px-1 md:px-0 relative">
        <BrandMenu />
        <LocationMenu />

        {/* Right-justify UserPopover and ModulePopover */}
        <div className="ml-auto flex items-center">
          <UserPopover />
          <ModulePopover />
        </div>

        {/* Overlay to disable the NavBar */}
        {isDisabled && (
          <div
            className="absolute inset-0 bg-black bg-opacity-50 z-50 cursor-not-allowed"
            style={{ pointerEvents: "all" }} // Block mouse events
          />
        )}
      </div>
    </div>
  );
};

export default NavBar;
